/** "Change requests" glyph (a pull-request mark), drawn like the sidebar's other icons: 1em, paths filled #787c7c. */
export function ChangeRequestsSVG() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true">
            <rect width="16" height="16" fill="none" />
            <g transform="translate(3.5 3) scale(0.6)">
                <path fillRule="evenodd" fill="#787c7c" d="M3 0a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5zm0 1.4a1.1 1.1 0 1 1 0 2.2a1.1 1.1 0 1 1 0-2.2z" />
                <path fillRule="evenodd" fill="#787c7c" d="M3 11.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5zm0 1.4a1.1 1.1 0 1 1 0 2.2a1.1 1.1 0 1 1 0-2.2z" />
                <path fillRule="evenodd" fill="#787c7c" d="M13 11.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5zm0 1.4a1.1 1.1 0 1 1 0 2.2a1.1 1.1 0 1 1 0-2.2z" />
                <path fill="#787c7c" d="M2.3 5.2h1.4v6.1H2.3z" />
                <path fill="#787c7c" d="M12.3 4.2h1.4v7.1h-1.4z" />
                <path fill="#787c7c" d="M8.5 2.8h5.2v1.4H8.5z" />
                <path fill="#787c7c" d="M9.6 0.4v5.8L6.2 3.5z" />
            </g>
        </svg>
    );
}
